module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-art-2.545c94af.png";